import React from 'react';

import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import 'moment/locale/ru';

import Select from 'react-select';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

const moment = require('moment');

class PeriodAndDisplaySelector extends React.Component {

    constructor(props) {
        super(props);

        this.displays = [];
        this.state = {
            periodMnemo: "day",
            displaysMnemo: "all",
            reportPeriodText: "",
            startDate: moment(),
            endDate: moment(),
            displays: []
        };

        moment.locale("ru");

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.props.onDatesChange(this.state.startDate.format("YYYY-MM-DD"), this.state.endDate.format("YYYY-MM-DD"));
    }

    componentDidMount() {

        api.makeRequest(api.getDisplaysDictionary()).then(
            (response) => {

                this.displays = response.data.data.map((item, i) => {
                    // return {
                    //     value: item.id,
                    //     label: item.name
                    // };
                    return {
                        value: item.id,
                        label: `${item.id} [${item.checkpoint.name} - ${item.checkpoint.description}]`
                    };
                });

                this.setState({
                    displays: this.displays
                });

                this.props.onDisplaysChange(this.displays.map(item => { return item.value }));
                if (this.props.onMount) {
                    this.props.onMount();
                }

                this.props.updateLoader({
                    loaded: true,
                    message: ""
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + error
                });

                if (this.props.onMount) {
                    this.props.onMount();
                }
            }
        );
    }

    setReportParams(parameter, value) {

        if (parameter === "period") {

            let startDt, endDt;
            endDt = moment();

            switch (value) {
                case "day":
                    startDt = moment();
                    break;

                case "week":
                    startDt = moment().add(-1, "w");
                    break;

                case "month":
                    startDt = moment().add(-1, "M");
                    break;

                case "year":
                    startDt = moment().add(-1, "y").add(2, "d");
                    break;
            }

            if (value === "custom") {
                this.setState({
                    periodMnemo: value,
                    startDate: null,
                    endDate: null,
                    startDateStr: "",
                    endDateStr: "",
                    periodError: ""
                },
                    this.props.onDatesChange("", "")
                );
            }
            else {
                this.setState({
                    startDate: startDt,
                    endDate: endDt,
                    periodMnemo: value,
                    periodError: ""
                },
                    this.props.onDatesChange(startDt.format("YYYY-MM-DD"), endDt.format("YYYY-MM-DD"))
                );
            }
        }
    }

    render() {
        return (
            <div>
                <div>
                    <label>Период</label>

                    <div class="list-group list-group-horizontal-md">
                        <button className={"list-group-item list-group-item-action" + (this.state.periodMnemo === "day" ? " active" : "")} onClick={() => this.setReportParams("period", "day")}>
                            День
                        </button>
                        <button className={"list-group-item list-group-item-action" + (this.state.periodMnemo === "week" ? " active" : "")} onClick={() => this.setReportParams("period", "week")}>
                            Неделя
                        </button>
                        <button className={"list-group-item list-group-item-action" + (this.state.periodMnemo === "month" ? " active" : "")} onClick={() => this.setReportParams("period", "month")}>
                            Месяц
                        </button>
                        <button className={"list-group-item list-group-item-action" + (this.state.periodMnemo === "year" ? " active" : "")} onClick={() => this.setReportParams("period", "year")}>
                            Год
                        </button>

                        <div className={"list-group-item list-group-item-action" + (this.state.periodMnemo === "custom" ? " active" : "")} onClick={() => this.setReportParams("period", "custom")}>
                            Произвольно...
                                            {
                                this.state.periodMnemo === "custom" &&
                                <div className="mt-3">
                                    <DateRangePicker
                                        startDate={this.state.startDate}
                                        endDate={this.state.endDate}
                                        focusedInput={this.state.focusedInput}
                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                        minDate={moment().add(-1, "y").add(2, "d")}
                                        maxDate={moment()}
                                        // maxDate={moment().add(1, "d")}
                                        onDatesChange={({ startDate, endDate }) => {
                                            // if (startDate) {
                                            //     this.setState({
                                            //         startDate: startDate
                                            //     },
                                            //         this.props.onDatesChange(
                                            //             startDate ? startDate.format("YYYY-MM-DD") : ""
                                            //         )
                                            //     );
                                            // }

                                            // if (endDate && endDate.isBefore(moment().hour(23).minute(59))) {
                                            //     this.setState({
                                            //         endDate: endDate
                                            //     },
                                            //         this.props.onDatesChange(
                                            //             endDate ? endDate.format("YYYY-MM-DD") : ""
                                            //         )
                                            //     );
                                            // }

                                            // this.setState({
                                            //     startDate: startDate,
                                            //     endDate: endDate
                                            // },
                                            //     this.props.onDatesChange(
                                            //         startDate ? startDate.format("YYYY-MM-DD") : "",
                                            //         endDate ? endDate.format("YYYY-MM-DD") : ""
                                            //     )
                                            // );

                                            this.setState({
                                                startDate: startDate,
                                                endDate: endDate
                                            },
                                                this.props.onDatesChange(
                                                    startDate ? startDate.format("YYYY-MM-DD") : "",
                                                    endDate && endDate.isBefore(moment().hour(23).minute(59)) ? endDate.format("YYYY-MM-DD") : ""
                                                )
                                            );
                                        }}
                                        minimumNights={0}
                                        numberOfMonths={1}
                                        small={true}
                                        startDatePlaceholderText="Начало"
                                        endDatePlaceholderText="Конец"
                                        enableOutsideDays={true}
                                        // isOutsideRange={() => false}
                                        isOutsideRange={(day) => {
                                            // if (this.state.focusedInput == "endDate") {
                                            //     return day.isAfter(moment(new Date())) || day.isBefore(this.state.startDate);
                                            // }
                                            // if (this.state.focusedInput == "startDate") {
                                            //     return day.isAfter(moment(new Date())) || day.isAfter(this.state.endDate) || day.isBefore(moment(new Date()).add(-1, "y").add(2, "d"));
                                            // }

                                            // if (this.state.focusedInput == "endDate") {
                                            //     return day.isAfter(moment()) || day.isBefore(this.state.startDate);
                                            // }
                                            // if (this.state.focusedInput == "startDate") {
                                            //     return day.isAfter(moment()) || day.isAfter(this.state.endDate) || day.isBefore(moment().add(-1, "y").add(2, "d"));
                                            // }

                                            return false;
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="mt-3">
                    <label>Табло</label>

                    <div class="list-group list-group-horizontal-md">
                        <button className={"list-group-item list-group-item-action" + (this.state.displaysMnemo === "all" ? " active" : "")}
                            onClick={() => {

                                this.setState({
                                    displays: this.displays,
                                    displaysMnemo: "all",
                                    displaysSelectError: ""
                                },
                                    this.props.onDisplaysChange(
                                        this.displays.map((item) => {
                                            return item.value;
                                        })
                                    )
                                )
                            }}>
                            Все
                        </button>


                        <div className={"list-group-item list-group-item-action" + (this.state.displaysMnemo === "custom" ? " active" : "")}
                            style={{ cursor: "pointer" }}
                        >
                            <div
                                onClick={() => {
                                    this.setState({
                                        displays: null,
                                        displaysMnemo: "custom",
                                        displaysSelectError: ""
                                    });

                                    this.props.onDisplaysChange([])
                                }
                                }
                            >
                                Произвольно...
                            </div>
                            {
                                this.state.displaysMnemo === "custom" &&
                                <div className="mt-3">
                                    <Select
                                        isMulti
                                        placeholder="Щёлкните для выбора..."
                                        options={this.displays}
                                        value={this.state.displays}
                                        onChange={(value) => {

                                            if (!value) {
                                                this.setState({
                                                    displays: []
                                                },
                                                    this.props.onDisplaysChange([])
                                                );
                                            }
                                            else {
                                                this.setState({
                                                    displays: value
                                                },
                                                    this.props.onDisplaysChange(value.map(item => { return item.value }))
                                                );
                                            }
                                        }}
                                        styles={{
                                            option: (provided) => ({
                                                ...provided,
                                                color: "#000"
                                            }),
                                            control: (provided) => ({
                                                ...provided,
                                                color: "#000"
                                            }),
                                        }}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PeriodAndDisplaySelector;